import React from 'react';
import PropTypes from 'prop-types';
import {Box, Heading, Skeleton} from '@tenancy.nz/ui';

function BookingFormHeader({heading = undefined, loading = false}) {
  if (loading) {
    return (
      <Box mb="8px">
        <Skeleton width="90%" height={25} />
      </Box>
    );
  }

  return (
    <Heading as="h1" gutterBottom>
      {heading}
    </Heading>
  );
}

BookingFormHeader.propTypes = {
  /**
   * Form section heading.
   */
  heading: PropTypes.string,

  /**
   * If `true`, will show loading state
   */
  loading: PropTypes.bool,
};

export default BookingFormHeader;
